import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { RandomGeneratorService } from '../helper/random-generator.service';
import { isNullOrUndefined } from '../helper/sla-util.helper';
import { TranslateCollectorService } from './translate-collector.service';

@Injectable({
    providedIn: 'root',
})
export class AssetsI18nLoader {

    protected myPriority: number = 0;
    protected supportedLanguages: string[];

    private subLanguages: Observable<any>;

    constructor(protected myHttp: HttpClient,
                protected myRandomGeneratorService: RandomGeneratorService,
                protected myTranslateCollectorService: TranslateCollectorService) {
    }

    public init(path?: string, libName?: string, prioriy?: number): Promise<void> {
        return new Promise(async (resolve: () => void): Promise<void> => {
            if (this.supportedLanguages) {
                for (let i: number = 0; i < this.supportedLanguages.length; i++) {
                    const tmp: string = this.supportedLanguages[ i ];
                    await this.loadTranslations(tmp, path, libName, prioriy);
                }
                resolve();
            } else {
                if (!this.subLanguages) {
                    this.subLanguages = this.myHttp.get(`assets/i18n/supported-languages.json?v=${this.myRandomGeneratorService.generateAlphaNumberId(10)}`)
                        .pipe(share());
                }
                this.subLanguages.subscribe(
                    async (res: any) => {
                        this.subLanguages = null;
                        this.supportedLanguages = res.languages;

                        for (let i: number = 0; i < this.supportedLanguages.length; i++) {
                            const tmp: string = this.supportedLanguages[ i ];
                            await this.loadTranslations(tmp, path, libName, prioriy);
                        }
                        resolve();
                    }, () => {
                        this.subLanguages = null;
                        console.error('Missing file -> assets/i18n/supported-languages.json <-- FIX THIS!');
                        resolve();
                    });
            }
        });
    }

    protected loadTranslations(lang: string, path?: string, libName?: string, prioriy?: number): Promise<void> {
        let filename: string = '';
        if (libName) {
            filename = `${libName}-${lang}.json`;
        } else {
            filename = `${lang}.json`;
        }

        return new Promise((resolve: () => void): void => {
            this.myHttp.get(`${(path || './assets/i18n/') + filename}?v=${this.myRandomGeneratorService.generateAlphaNumberId(10)}`).subscribe(
                (response: any) => {
                    this.myTranslateCollectorService.addTranslations(response, lang, prioriy || this.myPriority);
                    try {

                        const items: string = localStorage.getItem(`${lang}_current_translation_files`);
                        let list: string [] = [];
                        if (isNullOrUndefined(items) || items.length === 0) {
                            list.push(filename);
                            localStorage.setItem(`${lang}_current_translation_files`, JSON.stringify(list));
                        } else {
                            list = JSON.parse(items);
                            const found: string = list.find((entry: string) => entry === filename);
                            if (isNullOrUndefined(found)) {
                                list.push(filename);
                                localStorage.setItem(`${lang}_current_translation_files`, JSON.stringify(list));
                            }
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    resolve();
                }, (_err: unknown) => {
                    // warum leere Translations laden..?
                    // this.myTranslateCollectorService.addTranslations({}, lang, prioriy || this.myPriority);
                    resolve();
                });
        });
    }
}
